import { render } from "./appfooter.vue?vue&type=template&id=156c2bae"
import script from "./appfooter.vue?vue&type=script&lang=js"
export * from "./appfooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__